import ToolBarBottom from "../Components/header/ToolBarBottom.js";
import { connect } from "react-redux";
import { cancelPatternConverter } from "../store/actions/actions";
import { donePatternConverter } from "../store/actions/actions";

const mapStateToProps = (state) => {
  return {
    locale: state.locale,
    enableCRUD: state.enableCRUD,
    conversions: state.conversions,
  };
};

const mapDispatchToProps = { cancelPatternConverter, donePatternConverter };

/* Next line links component ToolBar, to:
-State variables defined on mapStateToProps
-functions defined on mapDispatchToProps */
export default connect(mapStateToProps, mapDispatchToProps)(ToolBarBottom);
